// LIBRERIE/IMPORTS
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserTie, faClock, faChartSimple  } from "@fortawesome/free-solid-svg-icons";

//IMG
import lenteImg from '../../../public/assets/images/inHome/lente.png';
import contractImg from '../../../public/assets/images/inHome/contract.jpg';

const ServicesSection: React.FC = () => {
  const { t } = useTranslation();

  const servicesIcon = [
    {
      icon:  <FontAwesomeIcon icon={faClock} />,
      title: t('homePage.servicesSection.serviceTitle1'),
      description: t('homePage.servicesSection.description1')
    },
    {
      icon: <FontAwesomeIcon icon={faChartSimple} />,
      title: t('homePage.servicesSection.serviceTitle2'),
      description: t('homePage.servicesSection.description2')
    },
    {
      icon: <FontAwesomeIcon icon={faUserTie} />,
      title: t('homePage.servicesSection.serviceTitle3'),
      description: t('homePage.servicesSection.description3')
    }
  ];

  /* transizione per apparizione icone + testi */
  const liServies = useRef<(HTMLLIElement|null)[]>([]);
  const setRef = (element: HTMLLIElement|null, index: number) => {
      liServies.current[index] = element;
  }
  const [visible, setVisible] = useState<boolean[]>([false,false,false])

  useEffect(() => {
    const handleScroll = () => {
      liServies.current.forEach((liElement, index) => {
          const liPosition = liElement?.getBoundingClientRect();
          const positionInDOM = liPosition? liPosition.bottom + window.scrollY : 0
          const clientViewHeight = window.scrollY + window.innerHeight;
          if( positionInDOM < clientViewHeight){
              setVisible((prevVisible) => {
                  const newVisible = [...prevVisible]; 
                  newVisible[index] = true; 
                  return newVisible;
              });
          }
      })
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
        window.removeEventListener("scroll", handleScroll);
    }
  }, [])
    
  return (
    <section id="service-box" className="space-ptb" >
      <div className="container-fluid">
        <div className="text-right">
          <h2 className="mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.servicesSection.title') as string }} />
          <p className="mb-5" dangerouslySetInnerHTML={{ __html: t('homePage.servicesSection.para1') as string }} />
        </div>
        <div className="row justify-content-center align-items-center">
          <div className="col-12 col-lg-7 col-xl-5">
            <ul className="list-unstyled mb-4 mb-lg-0">
              { servicesIcon.map((service, index) => (
                <li key={index} className={`d-md-flex align-items-center text-center mb-2 ${visible[index]? 'visible' : ''}`} ref={(element) => setRef(element, index)}>
                  <i>{service.icon}</i>
                  <div className="text-md-left">
                    <h4>{service.title}</h4>
                    <p dangerouslySetInnerHTML={{ __html: service.description as string }} />
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-12 col-sm-9 col-md-7 col-lg-5 col-xl-7">
            <div className="row">
              <div className="col-12 col-xl-6">
                <img src={contractImg} className="img-fluid" alt={`${t('homePage.servicesSection.imgAlt1')}`} />
              </div>
              <div className="d-none d-xl-block col-xl-6">
                <img src={lenteImg} className="img-fluid" alt={`${t('homePage.servicesSection.imgAlt2')}`} />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-around mt-4 brandValue">
          <i>-</i>
          <p>{t('homePage.servicesSection.brandValue1')}</p>
          <i className="d-none d-md-block">-</i>
          <p className="d-none d-md-block">{t('homePage.servicesSection.brandValue2')}</p>
          <i className="d-none d-xl-block">-</i>
          <p className="d-none d-xl-block">{t('homePage.servicesSection.brandValue3')}</p>
          <i>-</i>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;